import { FileType } from "@/Common/Models/FileType";
import { ExportableFile } from "../ExportableFile";
import { InfoFaxReceiverContactOverlayElement } from "../OverlayElements/InfoFaxReceiverContactOverlayElement";
import { OverlayElementType } from "../OverlayElements/OverlayElement";

export class UpdateFaxContactInfoDecorator {
    private readonly exportableFile: ExportableFile;

    public constructor(exportableFile: ExportableFile) {
        this.exportableFile = exportableFile;
    }

    public updateFaxContactInfo(name: string, faxNumber: string): ExportableFile {
        // Should only add overlay to exam request.
        // Adding overlay to a file type where you can sign using the draggable overlay will cause some weird behaviors.
        if (this.exportableFile?.fileType !== FileType.EXAMREQUEST) {
            return this.exportableFile;
        }

        const faxInfoContact = this.exportableFile.overlayElements.firstOrDefault(p => p.overlayElementType === OverlayElementType.InfoFaxReceiverContact) as InfoFaxReceiverContactOverlayElement;
        if (!faxInfoContact) {
            this.exportableFile.applyOverlayElement(new InfoFaxReceiverContactOverlayElement({ Name: name, FaxNumber: faxNumber }));
            this.exportableFile.showOverlayRefreshButton = true;
            return this.exportableFile;
        }

        const isDifferent = name !== faxInfoContact?.Name
            || faxNumber !== faxInfoContact?.FaxNumber;

        if (isDifferent) {
            faxInfoContact.Name = name;
            faxInfoContact.FaxNumber = faxNumber;
            this.exportableFile.showOverlayRefreshButton = true;
        }

        return this.exportableFile;
    }
}
